import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const MAX_PER_ORDER = 10;

export type ProductAvailability = { inStock: boolean; maxQuantity: number };

// Shared across components so the check runs once per page load.
let cached: Promise<ProductAvailability | null> | null = null;

export function fetchBrainChargeAvailability(force = false): Promise<ProductAvailability | null> {
  if (!cached || force) {
    cached = supabase.functions
      .invoke("get-product-availability", { body: { productKey: "brainCharge" } })
      .then(({ data, error }) => {
        if (error || !data || typeof data !== "object") return null;
        const d = data as { inStock?: boolean; maxOrderQty?: number };
        return {
          inStock: !!d.inStock,
          maxQuantity: Math.max(0, Math.min(MAX_PER_ORDER, Number(d.maxOrderQty ?? 0))),
        };
      })
      .catch(() => null);
  }
  return cached;
}

/** Returns null while loading or if the check failed (callers fall back to the 10-per-order cap). */
export function useProductAvailability(): ProductAvailability | null {
  const [value, setValue] = useState<ProductAvailability | null>(null);
  useEffect(() => {
    let active = true;
    fetchBrainChargeAvailability().then((v) => active && setValue(v));
    return () => {
      active = false;
    };
  }, []);
  return value;
}
